export const STANDARD_SUB = 'Standard';

export default [
  STANDARD_SUB,
  'Enhanced', 
  'Rental Only', 
  'Rental and Purchase', 
  'Other',
];



// WEBPACK FOOTER //
// src/constants/subscriptions.js